import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import deleteMergeSingleIntegrationService from 'services/integrations/delete-merge-single-integration-service'

type UseDeleteMergeSingleIntegrationProps = {} & MutateApiHookType<void>

function useDeleteMergeSingleIntegration({
  onSuccess,
  onError,
}: UseDeleteMergeSingleIntegrationProps) {
  const queryClient = useQueryClient()
  const { mutate: fetch, isLoading: pending } = useMutation(
    deleteMergeSingleIntegrationService,
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('/integrations')
        onSuccess?.()
      },
      onError,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useDeleteMergeSingleIntegration
